export default __webpack_public_path__ + "static/existing_biz_revenue-69eb4292b4e83638a1f504d0df926987.png";